import { externalLinkProps } from "../../utils/directoryUtils";

export default function DirectorySourceList({ sources = [] }) {
  const unique = [...new Set(sources.filter(Boolean))];
  if (!unique.length) return null;
  return (
    <section className="soft-card min-w-0 p-5 sm:p-7">
      <h2 className="text-2xl font-black tracking-tight text-neutral-950">Profile sources</h2>
      <ul className="mt-5 grid gap-3">
        {unique.map((source) => (
          <li key={source}>
            <a href={source} {...externalLinkProps()} className="focus-ring block break-words [overflow-wrap:anywhere] rounded-2xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm font-bold text-blue-700 hover:border-blue-300 hover:bg-blue-50">
              {source}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
